import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import BackIcon from '@mui/icons-material/Reply';
import ShowIcon from '@mui/icons-material/Visibility';
import UpIcon from '@mui/icons-material/ExpandLess';
import DownIcon from '@mui/icons-material/ExpandMore';
import MailIcon from '@mui/icons-material/Mail';
import EuroIcon from '@mui/icons-material/Euro';
import DownloadIcon from '@mui/icons-material/Download';
import OptionsIcon from '@mui/icons-material/MoreHoriz';
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/LiveHelp';
import SchoolIcon from '@mui/icons-material/School';
import ChatIcon from '@mui/icons-material/Forum';
import { Tooltip, IconButton, Box } from '@mui/material';
import { txt } from '../../services/translation';

export default function Tip({type, onClick, title}){

    const types = {
        show: { title: txt('showTitle'), icon: <ShowIcon /> },
        edit: { title: txt('editTitle'), icon: <EditIcon /> },
        delete: { title: txt('deleteTitle'), icon: <DeleteIcon /> },
        search: { title: txt('searchTitle'), icon: <SearchIcon /> },
        back: { title: txt('backTitle'), icon: <BackIcon /> },
        up: { title: txt('upTitle'), icon: <UpIcon /> },
        down: { title: txt('downTitle'), icon: <DownIcon /> },
        mail: { title: txt('mailTitle'), icon: <MailIcon /> },
        money: { title: txt('moneyTitle'), icon: <EuroIcon /> },
        download: { title: txt('downloadTitle'), icon: <DownloadIcon /> },
        options: { title: txt('optionsTitle'), icon: <OptionsIcon /> },
        help: { title: txt('helpTitle'), icon: <HelpIcon /> },
        close: { title: txt('closeTitle'), icon: <CloseIcon /> },
        learn: { title: txt('learnTitle'), icon: <SchoolIcon /> },
        chat: { title: txt('chatTitle'), icon: <ChatIcon /> },
    };

    let label = title === false ? false : (title || types[type].title)

    return <Box>
        <Tooltip title={label} arrow onClick={() => onClick ? onClick() : false}>
            <IconButton size='small'>
                {types[type].icon}
            </IconButton>
        </Tooltip>
    </Box>
}